import styled from 'styled-components';

export const MobileCloseIconContainer = styled.div`
  display: none;
  position: fixed;
  bottom: 20px;
  @media (max-width: 1199px) {
    display: flex;
  }
  @media (min-height: 737px) {
    align-items: flex-end;
    height: 100%;
  }
  > div {
    width: 50px;
    height: 50px;
    background-color: var(--white);
    border-radius: 30px;
    padding: 10px;
  }
`;
